import { ModelBase } from 'store/model-base';

import { NetworkDeviceStatus } from 'my-account/constants';

export class NetworkDevice extends ModelBase {
    public static storeName: string = 'networkDevice';

    public id: Id;
    public imei: string;
    public iccid: string;
    public status: NetworkDeviceStatus;
    public hotLined: boolean;
    public associatedLines: Id;
    public isCdma: boolean;
    public networkFeaturesAligned: boolean;
    public productDetails: NetworkDeviceDetails;

    public name: string;
    public description: string;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.name = data.productDetails && `${data.productDetails.brand} ${data.productDetails.model}` || '';
        data.description = data.productDetails && `${data.productDetails.model}, ${data.productDetails.capacity}, ${data.productDetails.colorName}` || '';

        return super.create<T>(data);
    }
}
